$(document).ready(function(){
      $('.pro-var-options').on('change', function(){
          var get_var_id = $(this).find('option:selected').attr('value');
          console.log(get_var_id);
        $('input.product-variant-id').val(get_var_id);
          $('.product-form__item button').attr('pro_id',get_var_id);
              var selectedOption = $('#ProductSelect option:selected').text();
          var dateMatch = selectedOption.match(/(\d{1,2} \w+ \d{4} - \d{1,2} \w+ \d{4})/);
          if (dateMatch) {
              console.log(dateMatch[0]); 
            $('span.toue-date-wrp').text(dateMatch[0]);
          } else {
              console.log("No date found.");
          }

        var selectedOption_sec = $('#ProductSelect option:selected').attr('ctm-val');
        if(selectedOption_sec == 'choose_your_own_dates'){
            $('.ctm-date-picker-pop').show();
            $('body').addClass('waiver-sign-popup-show'); 
        }
      });
  
  $('ul.footer-block__details-content.list-unstyled li').on('click',function(){
    $(this).find('.wrp-nav-chid').slideToggle();
});
  
  $(".nav_tabs_wrp a[href^='#']").click(function(e) {
	e.preventDefault();
	
	var position = $($(this).attr("href")).offset().top;

	$("body, html").animate({
		scrollTop: position - 50
	},100 );
});

  /*************double slider section---start*************/
if($('.featuredItemsSliderWrap_main').length){
$('.mobileslider').slick({
          slidesToShow: 1,
          speed: 500,
          autoplaySpeed: 5000,
          infinite: true,
          autoplay: false,
  swipeToSlide: true,
         centerMode: true,
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 4.5C13.2761 4.5 13.5 4.27614 13.5 4C13.5 3.72386 13.2761 3.5 13 3.5L13 4.5ZM0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.97631 4.7308 0.659728 4.53553 0.464465C4.34027 0.269203 4.02369 0.269203 3.82843 0.464465L0.646446 3.64645ZM13 3.5L1 3.5L1 4.5L13 4.5L13 3.5Z" fill="white"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5L1 3.5ZM13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464467C9.97631 0.269205 9.65973 0.269205 9.46447 0.464467C9.2692 0.659729 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM1 4.5L13 4.5L13 3.5L1 3.5L1 4.5Z" fill="white"/></svg></button>'
});

  $('.featuredItems-images').slick({
	arrows : true,
	dots : false,
	adaptiveHeight : true,
    speed: 500,
	autoplaySpeed : 5000,
	asNavFor : '.featuredItems-texts',
	slidesToShow: 3,
    slidesToScroll: 1,
	infinite: true,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 4.5C13.2761 4.5 13.5 4.27614 13.5 4C13.5 3.72386 13.2761 3.5 13 3.5L13 4.5ZM0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.97631 4.7308 0.659728 4.53553 0.464465C4.34027 0.269203 4.02369 0.269203 3.82843 0.464465L0.646446 3.64645ZM13 3.5L1 3.5L1 4.5L13 4.5L13 3.5Z" fill="white"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5L1 3.5ZM13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464467C9.97631 0.269205 9.65973 0.269205 9.46447 0.464467C9.2692 0.659729 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM1 4.5L13 4.5L13 3.5L1 3.5L1 4.5Z" fill="white"/></svg></button>',
    responsive: [
    {
      breakpoint: 1919,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1365,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$('.featuredItems-texts').slick({
	fade : true,
  arrows : false,
    speed: 500,
	autoplaySpeed : 5000,
	asNavFor : '.featuredItems-images',
	autoplay : false,
	vertical: false,
	    infinite: true
// verticalSwiping: true
});

$('.tandemSlider-1').slick();
}

  /*************double slider section---end*************/


/*************review section slider---start*************/

 $('.testimonials-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 4.5C13.2761 4.5 13.5 4.27614 13.5 4C13.5 3.72386 13.2761 3.5 13 3.5L13 4.5ZM0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.97631 4.7308 0.659728 4.53553 0.464465C4.34027 0.269203 4.02369 0.269203 3.82843 0.464465L0.646446 3.64645ZM13 3.5L1 3.5L1 4.5L13 4.5L13 3.5Z" fill="white"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5L1 3.5ZM13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464467C9.97631 0.269205 9.65973 0.269205 9.46447 0.464467C9.2692 0.659729 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM1 4.5L13 4.5L13 3.5L1 3.5L1 4.5Z" fill="white"/></svg></button>',
   fade: false,
   responsive: [
    {
      breakpoint: 749,
      settings: {
        dots: true,
         arrows: false
      }
    }
  ]
 });
/*************review section slider---end*************/
  
  /*************gallery slider-- start****************/
  if (window.innerWidth < 749 ) {
  $('.featured-gallery-inner').slick({
    dots: false,
    infinite: true,
    slidesToShow: 2.05,
    arrows: false
 });
  }
  /*************gallery slider-- end****************/

  
  /*************accomodation slider-- start****************/
  if($('body').hasClass('template-product')){
    $('.accommodations_slider').slick({
          dots: false,
          infinite: true,
          arrows:true,
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 4.5C13.2761 4.5 13.5 4.27614 13.5 4C13.5 3.72386 13.2761 3.5 13 3.5L13 4.5ZM0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.97631 4.7308 0.659728 4.53553 0.464465C4.34027 0.269203 4.02369 0.269203 3.82843 0.464465L0.646446 3.64645ZM13 3.5L1 3.5L1 4.5L13 4.5L13 3.5Z" fill="white"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5L1 3.5ZM13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464467C9.97631 0.269205 9.65973 0.269205 9.46447 0.464467C9.2692 0.659729 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM1 4.5L13 4.5L13 3.5L1 3.5L1 4.5Z" fill="white"/></svg></button>',
          speed: 500,
          slidesToShow: 1,
          adaptiveHeight: true
        }); 
  }
  /*************accomodation slider-- end****************/
  
    $(".top_buttons_section").slick({
   slidesToShow: 7,
   infinite:false,
   slidesToScroll: 1,
   autoplay: false,
   autoplaySpeed: 2000,
   dots: false,
   arrows: true,
   draggable: false,
   prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 4.5C13.2761 4.5 13.5 4.27614 13.5 4C13.5 3.72386 13.2761 3.5 13 3.5L13 4.5ZM0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.97631 4.7308 0.659728 4.53553 0.464465C4.34027 0.269203 4.02369 0.269203 3.82843 0.464465L0.646446 3.64645ZM13 3.5L1 3.5L1 4.5L13 4.5L13 3.5Z" fill="white"/></svg></button>',
   nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5L1 3.5ZM13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464467C9.97631 0.269205 9.65973 0.269205 9.46447 0.464467C9.2692 0.659729 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM1 4.5L13 4.5L13 3.5L1 3.5L1 4.5Z" fill="white"/></svg></button>',
   accessibility: true,
    responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    ]
  });

  
      $('#select-dates-custom').on('click', function() {
         $('.ctm-date-picker-pop').show();
        $('body').addClass('waiver-sign-popup-show');
      });
  
});